// extracted by mini-css-extract-plugin
module.exports = {"post":"post-styles_post__VW9NB"};